import styled from "styled-components";

export const DonateContainer = styled.div`
  background-color: ${({ isDiv }) => (isDiv ? "#fefefa" : "transparent")};
  display: flex;
  justify-content: center;
  align-items: center;
  padding: ${({ isDiv }) => (isDiv ? "80px" : "120px")};
  margin-top: ${({ isDiv }) => (isDiv ? "0" : "-200px")};

  @media screen and (max-width: 856px) {
    padding-top: ${({ isDiv }) => (isDiv ? "80px" : "0")};
    padding-bottom: ${({ isDiv }) => (isDiv ? "80px" : "85px")};
    margin-top: ${({ isDiv }) => (isDiv ? "0" : "-50px")};
  }

  @media screen and (max-width: 456px) {
    padding-top: ${({ isDiv }) => (isDiv ? "80px" : "0")};
    padding-bottom: ${({ isDiv }) => (isDiv ? "80px" : "70px")};
    margin-top: ${({ isDiv }) => (isDiv ? "0" : "-50px")};
  }
`;
export const DonateForm = styled.form``;

export const DonateInput = styled.input`
  width: 400px;

  @media screen and (max-width: 556px) {
    width: 300px;
  }
`;
export const DonameImg = styled.img``;
